import { Navigate, useLocation } from "react-router-dom";

/** Where Settings → Connectors lives. */
export const CONNECTORS_SETTINGS_PATH = "/settings/connectors";

/** The calendar's old Settings addresses, `/settings/connected-accounts`
 *  and `/settings/calendar` (#12394, round 26 decision 3): a calendar
 *  sign-in started before the move returns there, so they land on
 *  Connectors with whatever the sign-in sent back. Its own file, so the
 *  app's entry chunk takes no page with it. */
export function ConnectorsSettingsRedirect() {
  const { search, hash } = useLocation();
  return (
    <Navigate to={`${CONNECTORS_SETTINGS_PATH}${search}${hash}`} replace />
  );
}
